






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ParametroRelatorio} from '@/model/resource/ParametroRelatorio'
import {InputParametroRelatorioSchema} from '@/schema/resource/ParametroRelatorio/InputParametroRelatorioSchema'

@Component
export default class PersistParametroRelatorioView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputParametroRelatorioSchema()
  parametroRelatorio = new ParametroRelatorio()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionRelatorioGeracao.listRelatorioGeracao()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.parametroRelatorio.getParametroRelatorio(id)
    }

    $.await.done('getParametroRelatorio')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.parametroRelatorio.persistParametroRelatorio()
    await Helper.successAndPush(
      'system.success.persist',
      '/parametro-relatorio/list'
    )
  }
}
